import { deepEquals } from 'app/infrastructure/js';
import { isObject } from 'lodash';

/**
 * Creates a copy of given object without given properties.
 */
export const copyWithoutProperties = <T extends object>(source: T, properties: string[] = []): T =>
  source
    ? Object.keys(source)
      .filter(key => !properties.includes(key))
      .reduce<T>((result, key) => ({ ...result, [key]: source[key] }), {} as T)
    : {} as T;

export const objectOfType = <T>() => ({} as T);

export const isObjectEmpty = (object: object) => deepEquals(object, {}) || (isObject(object) &&
  Object.keys(object).find(key => object[key] !== undefined) === undefined);
